import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotfoundComponent } from './shared/errorpages/notfound/notfound.component';
import { AppLayoutComponent } from './shared/layout/app-layout/app-layout.component';
import { AuthGuardService } from './core/services/auth-guard.service';
import { AuthenticationComponent } from './authentication/authentication.component';
import { AppComponent } from './app.component';
import { RedirectGuard } from './shared/routeguards/redirect.guard';


const routes: Routes = [
  // App routes goes here here
  {
    path: '',
    // component: AppComponent,
    children: [
      {
        path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module')
          .then(m => m.DashboardModule)
      },
      {
        path: 'shared', loadChildren: () => import('./shared/shared.module')
          .then(m => m.SharedModule), canActivate: [AuthGuardService]
      },
      {
        path: 'lobby', loadChildren: () => import('./lobby/lobby.module')
          .then(m => m.LobbyModule), canActivate: [AuthGuardService]
      },
      {
        path: 'appointment', loadChildren: () => import('./appointment/appointment.module')
          .then(m => m.AppointmentModule), canActivate: [AuthGuardService]
      },
      {
        path: 'admin', loadChildren: () => import('./admin/admin.module')
          .then(m => m.AdminModule), canActivate: [AuthGuardService]
      },
      {
        path: 'master', loadChildren: () => import('./master/master.module')
          .then(m => m.MasterModule), canActivate: [AuthGuardService]
      },
      {
        path: 'report', loadChildren: () => import('./report/report.module')
          .then(m => m.ReportModule), canActivate: [AuthGuardService]
	  },
      { 
        path: 'external/:url', canActivate: [RedirectGuard],
        component: RedirectGuard
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
